import React, { useEffect, useState } from "react";

import useWindowSize from "../hooks/useWindowSize";
import { IconName } from "../types";
import Rendivo from "../util/rendivo";
import Carousel from "./Carousel";
import EllipsisLoader from "./EllipsisLoader";
import Fancybox from "./Fancybox";
import Icon from "./Icon";
import Selectable from "./Selectable";

const StyleHeroBanner = (props: {
  images: string[];
  tagline?: string;
  onSlide?: (index: number) => void;
  fancybox?: boolean;
  currentSlideIndex?: number;
  showRendivoDisclaimer: boolean;
  usingRendivoImages: boolean;
}) => {
  const [currentImage, setCurrentImage] = useState<string | null>(null);
  const windowSize = useWindowSize();
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    if (props.images.length > 0) {
      setCurrentImage(props.images[0]);
    }
  }, []);

  const onSlide = (index: number) => {
    setShowLoader(false); // Bug in iOS safari that messes up z-index when sliding
    if (props.onSlide) {
      props.onSlide(index);
    }
  };
  const onSlideEnd = () => {
    setShowLoader(true);
  };
  return (
    <Selectable
      selected={true}
      insetTick={windowSize.width < 768}
      className={"pyht-style-hero-banner"}
    >
      <div className={"inner"}>
        {props.fancybox && currentImage && (
          <Fancybox
            id={(Math.random() + 1).toString(36).substring(7)}
            href={currentImage}
          >
            <div className={"fullscreen-btn"} role={"button"}>
              <Icon name={IconName.FULLSCREEN} />
            </div>
          </Fancybox>
        )}
        <div className={"carousel-container"}>
          <Carousel
            onSlide={onSlide}
            onSlideEnd={onSlideEnd}
            hidePagination
            key={props.images.length}
            currentSlideIndex={props.currentSlideIndex}
            itemWidthPerc={100}
            spacingPx={0}
            items={props.images.map((image, index) => {
              return (
                <div className={"slide-container"} key={index}>
                  <div className={"hero-container"}>
                    {showLoader && <EllipsisLoader />}
                    {props.usingRendivoImages ? (
                      <img className={"hero"} src={image} srcSet={Rendivo.getSrcsetFromRendivoUrl(image, 1640)} sizes="(max-width: 1640px) 100vw, 1640px" alt={""} />
                    ) : (
                      <img className={"hero"} src={image} alt={""} />
                    )}
                  </div>
                </div>
              );
            })}
          />
          {props.showRendivoDisclaimer && (
            <div className={"rendivo-disclaimer"}>
              <p>Exclusive Preview.</p>
              <p>Colours shown are available from 1st Aug.</p>
            </div>
          )}
          {props.tagline && <p className={"tagline"}>{props.tagline}</p>}
        </div>
      </div>
    </Selectable>
  );
};

export default StyleHeroBanner;
